import Vue from 'vue'
import Router from 'vue-router'
import js from '@/components/js'

import Main from '@/views/home_one'
import Navbar from '@/components/navbar'
import NavbarMore from '@/components/navbar_more'
import About from '@/components/about'
import Feature from '@/components/feature'
import ContactUs from '@/components/contact_us'
import Screenshots from '@/components/screenshots'
import More from '@/components/more'
import Testimonial from '@/components/testimonial'
import Footer from '@/components/footer'
import BlogDetails from '@/components/blog_details'

Vue.use(Router)
Vue.component('Navbar', Navbar)
Vue.component('NavbarMore', NavbarMore)
Vue.component('About', About)
Vue.component('Feature', Feature)
Vue.component('Contact_us', ContactUs)
Vue.component('Screenshots', Screenshots)
Vue.component('More', More)
Vue.component('Testimonial', Testimonial)
Vue.component('BlogDetails', BlogDetails)
Vue.component('Footer', Footer)
Vue.component('js', js)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Main_page',
      components: {
        default: Main,
        navbar: Navbar,
      }
    },
    {
      path: '/sobre',
      name: 'Sobre_nos',
      components: {
        default: BlogDetails,
        navbar: NavbarMore,
      }
    },
    {
      path: '/more',
      name: 'Ver_mais',
      components: {
        default: More,
        navbar: NavbarMore,
      }
    },
    // {
    //   path: '*',
    //   redirect: '/tovo/404'
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js